import { render, staticRenderFns } from "./NotesEditerDialog.vue?vue&type=template&id=6a39be8c"
import script from "./NotesEditerDialog.vue?vue&type=script&lang=js"
export * from "./NotesEditerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports